import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalFooterComponent } from './portal-footer/portal-footer.component';
import { SharedModule } from '../modules/shared/shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, PortalFooterComponent],
  exports: [PortalFooterComponent],
})
export class LayoutModule {}
